<template>
  <div class="pageContent">
    <div class="table_box">
      <el-table :data="tableData" style="width: 100%;margin: 20px">
        <el-table-column prop="ordersn" label="订单号"> </el-table-column>
        <el-table-column prop="money" label="应付金额"> </el-table-column>
        <el-table-column prop="amount" label="实付金额"> </el-table-column>
        <el-table-column prop="dec_money" label="使用金额"> </el-table-column>
        <el-table-column prop="create_time" label="使用时间">
          <template slot-scope="scope">
            <div>{{ scope.row.create_time | dataFormat }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="total_num"
      @current-change="pagePost"
      :page-size="num"
      :hide-on-single-page="total_num<=10"
    >
    </el-pagination>
  </div>
</template>

<script>
import { card_order_user_logs } from "@/api/platform_card";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["app_id"])
  },
  data() {
    return {
      tableData: [],
      page:1,
      total_num:0,
      num:0
    };
  },
  mounted() {
    this.use_list();
  },
  methods: {
    pagePost(val){
      console.log(val)
      this.page = val
      this.use_list()
    },
    async use_list() {
      const res = await card_order_user_logs({
        app_id: this.app_id,
        id: this.$route.query.id,
        page:this.page
      });
      this.tableData = res.data.result;
      this.total_num = res.data.total_num
      this.num = res.data.num
    }
  }
};
</script>

<style lang="scss" scoped>
.pageContent {
  border: 20px solid #f1f2f6;
  padding: 0 20px 10px 20px;
  height: 100%;
  overflow: auto;
.options {
  line-height: 79px;
}
.table_box {
  margin-bottom: 20px;
}
.form_input {
  width: 240px;
}
}
</style>
